import { styled, css } from 'next-yak'
import * as colors from '../../constants/colors'

export type RadiomarkStatus = 'checked' | 'focused'

type RadiomarkProps = {
  $size?: number
  $status?: RadiomarkStatus
  $disabled?: boolean
}

export const Radiomark = styled.span<RadiomarkProps>`
  display: inline-block;
  color: inherit;
  fill: currentColor;
  vertical-align: baseline;
  border: 2px solid ${colors.PRIMARY_GREY_500};
  position: relative;
  border-radius: 50%;
  background-color: ${colors.PRIMARY_GREY_000};
  box-sizing: border-box;
  ${({ $size = 18 }) => css`
    width: ${() => $size}px;
    height: ${() => $size}px;
  `}
  ${({ $status }) => {
    if ($status === 'checked') {
      return css`
        border-color: ${colors.PRIMARY_BLUE_500};
      `
    }
    if ($status === 'focused') {
      return css`
        border-color: ${colors.PRIMARY_SAND_900};
      `
    }
  }}
  ${({ $disabled }) =>
    $disabled &&
    css`
      border-color: ${colors.PRIMARY_GREY_500};
      background-color: ${colors.SECONDARY_GREY_400};
    `}

  &::before {
    content: '';
    position: absolute;
    top: 3px;
    left: 3px;
    border-radius: 50%;
    background-color: ${colors.PRIMARY_BLUE_500};
    ${({ $size = 18 }) => css`
      width: ${() => $size - 10}px;
      height: ${() => $size - 10}px;
    `}
    ${({ $status }) => {
      if ($status !== 'checked') {
        return css`
          display: none;
        `
      }
    }}
    ${({ $disabled }) =>
      $disabled &&
      css`
        background-color: ${colors.PRIMARY_GREY_500};
      `}
  }
`

export const SmallGroup = styled.div`
  display: inline-flex;
  flex-direction: column;
`

export const BigGroup = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const MediumGroup = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
`
